export default __webpack_public_path__ + "static/media/AntrimDirectAssessmentUnit(DAU)v5.2220505AntrimDirectAssessmentUnitguidelineV5_2_flowchart.179f7ef1.jpg";